import PropTypes from "prop-types";
import * as React from "react";
import SignType from "../../../domain/signType";
import { usd } from "../../../util/formatCurrency";
import { Typography } from "../../../themeV2";
import ProductThumbnail from "../../ProductThumbnail/ProductThumbnail";
import SignTypeChip from "../../SignTypeChip/SignTypeChip";
import css from "./ListingPreview.module.css";

const ListingPreview = function ListingPreview({
  name,
  imageUrl,
  aspectRatio,
  signedType,
  price,
  customerPays,
  stock,
  productTypeName,
}) {
  return (
    <li className={css.card}>
      <ProductThumbnail
        src={imageUrl ?? undefined}
        alt=""
        inset={aspectRatio !== 1}
        className={css.image}
      >
        <div className={css.badge}>
          <SignTypeChip
            signedType={signedType}
            label={SignType.toLabel(signedType)}
          />
        </div>
      </ProductThumbnail>
      <div className={css.body}>
        <Typography
          variant="body-lg"
          weight="bold"
          as="h4"
          className={css.name}
        >
          {name}
        </Typography>
        <Typography variant="title-lg" as="p" className={css.price}>
          {usd(price)}
        </Typography>
        <p className={css.type}>{productTypeName}</p>
        <Typography variant="body-sm" color="variant" as="p">
          Customer pays {usd(customerPays)} · Stock: {stock ?? "Unlimited"}
        </Typography>
      </div>
    </li>
  );
};

ListingPreview.propTypes = {
  aspectRatio: PropTypes.number.isRequired,
  customerPays: PropTypes.number.isRequired,
  imageUrl: PropTypes.string,
  name: PropTypes.string.isRequired,
  price: PropTypes.number.isRequired,
  productTypeName: PropTypes.string.isRequired,
  signedType: PropTypes.string.isRequired,
  stock: PropTypes.number,
};

export default ListingPreview;
